import { useState } from "react";
import { useTranslation } from "react-i18next";


const RealWorldImpact: React.FunctionComponent<{}> = (props) => {

    const { t, i18n } = useTranslation();

    const [selectedContent, setSelectedContent] = useState<number>(1);

    const handleSelectedContent = (value: number) => {
        setSelectedContent(value);
    };

    const getImagePath = (fileName: any) => {
        return `/assets/images/${i18n.language}/${fileName}`;
    };

    return (
        <>

            {/* Real-World Impact for Developers */}
            <div className="basic-enh back-sect2  marg-2rem">
                <div className="container padd-20-bottom">
                    <div className="row">
                        <div className="col-lg-12">
                            <h3 className="h3-heading">{t("Real-World Impact")} <span> {t("for Developers")} </span></h3>
                        </div>
                    </div>
                    <div className="row mt-enh dir-rtl">
                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="pills-Moderation-tab" data-bs-toggle="pill" data-bs-target="#pills-Moderation" type="button" role="tab" aria-controls="pills-Moderation" aria-selected="true" onClick={() => handleSelectedContent(1)}>{t("Accelerate Sales Cycles")}</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="pills-Enhancement-tab" data-bs-toggle="pill" data-bs-target="#pills-Enhancement" type="button" role="tab" aria-controls="pills-Enhancement" aria-selected="false" onClick={() => handleSelectedContent(4)}>{t("Increase Marketing ROI")}</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="pills-Engagement-tab" data-bs-toggle="pill" data-bs-target="#pills-Engagement" type="button" role="tab" aria-controls="pills-Engagement" aria-selected="false" onClick={() => handleSelectedContent(7)}>{t("Optimize Operational Efficiency")}</button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-Moderation" role="tabpanel" aria-labelledby="pills-Moderation-tab">
                                <div className="row dir-rtl align-items-center">
                                    <div className="col-lg-6 col-xl-6">
                                        <div className="sidebar">
                                            <ul>
                                                <li className={`marg-40 ${selectedContent === 1 ? 'active' : ''}`} onClick={() => handleSelectedContent(1)}>
                                                    <h6 className="title">{t("Engaging Visuals")}</h6>
                                                    {selectedContent === 1 && <p className="para padd-0">{t("High-quality images and virtual tours")}</p>}
                                                </li>
                                                <li className={`marg-40 ${selectedContent === 2 ? 'active' : ''}`} onClick={() => handleSelectedContent(2)}>
                                                    <h6 className="title">{t("Enhanced Buyer Confidence")}</h6>
                                                    {selectedContent === 2 && <p className="para padd-0">{t("Detailed visuals and transparent information")}</p>}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-xl-6">
                                        <div className="image-container">
                                            {selectedContent === 1 && <img className="img-fluid" src={"/assets/images/Frame 11712755-1.webp"} alt="alternative" />}
                                            {selectedContent === 2 && <img className="img-fluid" src={"/assets/images/Frame 11712755-2.webp"} alt="alternative" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="pills-Enhancement" role="tabpanel" aria-labelledby="pills-Enhancement-tab">
                                <div className="row dir-rtl align-items-center">
                                    <div className="col-lg-6 col-xl-6">
                                        <div className="sidebar">
                                            <ul>
                                                <li className={`marg-40 ${selectedContent === 4 ? 'active' : ''}`} onClick={() => handleSelectedContent(4)}>
                                                    <h6 className="title">{t("Cost Savings")}</h6>
                                                    {selectedContent === 4 && <p className="para padd-0">{t("Reduce the need for expensive photo shoots")}</p>}
                                                </li>
                                                <li className={`marg-40 ${selectedContent === 5 ? 'active' : ''}`} onClick={() => handleSelectedContent(5)}>
                                                    <h6 className="title">{t("Higher Conversion Rates")}</h6>
                                                    {selectedContent === 5 && <p className="para padd-0">{t("Improved listings attract more qualified leads")}</p>}
                                                </li>
                                               
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-xl-6">
                                        <div className="image-container">
                                            {selectedContent === 4 && <img className="img-fluid" src={"/assets/images/Frame 11712755-3.webp"} alt="alternative" />}
                                            {selectedContent === 5 && <img className="img-fluid" src={"/assets/images/Frame 11712755-4.webp"} alt="alternative" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="pills-Engagement" role="tabpanel" aria-labelledby="pills-Engagement-tab">
                                <div className="row dir-rtl align-items-center">
                                    <div className="col-lg-6 col-xl-6">
                                        <div className="sidebar">
                                            <ul>
                                                <li className={`marg-40 ${selectedContent === 7 ? 'active' : ''}`} onClick={() => handleSelectedContent(7)}>
                                                    <h6 className="title">{t("Time Savings")}</h6>
                                                    {selectedContent === 7 && <p className="para padd-0">{t("Automate repetitive tasks like data entry")}</p>}
                                                </li>
                                                <li className={`marg-40 ${selectedContent === 8 ? 'active' : ''}`} onClick={() => handleSelectedContent(8)}>
                                                    <h6 className="title">{t("Reduced Errors")}</h6>
                                                    {selectedContent === 8 && <p className="para padd-0">{t("Minimize human errors in document processing")}</p>}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-xl-6">
                                        <div className="image-container">
                                            {selectedContent === 7 && <img className="img-fluid" src="/assets/images/Frame 11712755-5.webp" alt="alternative" />}
                                            {selectedContent === 8 && <img className="img-fluid" src="/assets/images/Frame 11712755-6.webp" alt="alternative" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )

}
export default RealWorldImpact;